import Error from "react/components/Error";

export function NotAuthorized() {
    return <Error code="403" />;
}
